import React, { useEffect } from "react";

import HomeHero from "./HomeHero";
import HomeEmpowerSection from "./HomeEmpowerSection";
import HomeInfluencerSection from "./HomeInfluencerSection";
import HomeAboutSection from "./HomeAboutSection";
import HomeBrandSection from "./HomeBrandSection";
import HomeRoutineSection from "./HomeRoutineSection";
import HomeBestsellersSection from "./HomeBestsellersSection";
import HomeSeventhSection from "./HomeSeventhSection";
import HomeTrendingSection from "./HomeTrendingSection";
import HomeVideoSections from "./HomeVideoSections";
import HomeCategorySection from "./HomeCategorySection";
import HomeLoveYourScreen from "./HomeLoveYourScreen";
import HomeNewBeauty from "./HomeNewBeauty";
import HomeTestimonial from "./HomeTestimonial";
import HomeBeautyVibeSection from "./HomeBeautyVibeSection";
import HomeFeatures from "./HomeFeatures";
import HomeNewsletterSection from "./HomeNewsletterSection";

const Home = () => {
  useEffect(() => {
    document.body.style.overflowX = "hidden";
  }, []);

  return (
    <>
      <HomeHero />
      <HomeEmpowerSection />
      <HomeInfluencerSection />
      <HomeAboutSection />
      <HomeBrandSection />
      <HomeRoutineSection />
      <HomeBestsellersSection />
      <HomeSeventhSection />
      <HomeTrendingSection />
      <HomeVideoSections />
      <HomeCategorySection />
      <HomeLoveYourScreen />
      <HomeNewBeauty />
      <HomeTestimonial />
      <HomeBeautyVibeSection />
      <HomeFeatures />
      <HomeNewsletterSection />
    </>
  );
};

export default Home;